<template>
  <button
    type="button"
    class="so-hold relative overflow-hidden rounded text-white font-semibold text-base select-none"
    :class="[{ 'so-hold--armed': done, 'so-hold--success': tone === 'success' }, block ? 'w-full' : 'px-6']"
    :disabled="disabled || sending"
    @pointerdown.prevent="start"
    @pointerup="stop"
    @pointerleave="stop"
    @pointercancel="stop"
    @keydown.enter.prevent="fire"
    @keydown.space.prevent="fire"
  >
    <span class="so-hold__fill" :style="{ width: progress * 100 + '%' }"></span>
    <span class="relative z-10 inline-flex items-center"><BaseIcon :icon="icon" class="mr-2" />{{ sending ? $t("securone.broadcast.sending") : label }}</span>
  </button>
</template>

<script>
// D-10 hold-to-send. Hold ~900 ms; fires once on completion of the hold, no
// countdown. The parent sends and calls reset() if the send failed.
const HOLD_MS = 900;

export default {
  name: "HoldButton",
  props: {
    label: { type: String, required: true },
    icon: { type: String, default: "broadcast-tower" },
    tone: { type: String, default: "danger" }, // danger | success
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    sending: { type: Boolean, default: false },
  },
  data() {
    return { progress: 0, done: false, t0: 0, raf: 0 };
  },
  methods: {
    start() {
      if (this.done || this.sending || this.disabled) return;
      this.t0 = Date.now();
      const step = () => {
        this.progress = Math.min(1, (Date.now() - this.t0) / HOLD_MS);
        if (this.progress >= 1) return this.fire();
        this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    },
    stop() {
      if (this.done) return;
      cancelAnimationFrame(this.raf);
      this.progress = 0;
    },
    fire() {
      if (this.done || this.sending || this.disabled) return;
      this.done = true;
      this.progress = 1;
      this.$emit("fire");
    },
    reset() {
      cancelAnimationFrame(this.raf);
      this.done = false;
      this.progress = 0;
    },
  },
  beforeDestroy() {
    cancelAnimationFrame(this.raf);
  },
};
</script>
